import { useImageAnnotatorContext } from "@msuite/image-annotator";
import { getUnitTranslationKey } from "@msuite/utils/strings";
import type { DimensionAnnotation } from "@msuite/utils/types";
import { sizeUnits } from "@msuite/utils/units";
import { useTranslation } from "../../../localization";

export function AnnotationToolbarSubMenuUnit() {
	/** Context */
	const context = useImageAnnotatorContext();
	const selectedAnnotation = context.controller.getSelectedAnnotation() as DimensionAnnotation;

	/** Hooks */
	const { t } = useTranslation();

	/** Guard */
	if (!selectedAnnotation) return null;

	/** Render */
	return (
		<select
			className="bg-primary-900 text-white text-xs rounded-md border-[0.5px] border-primary-700 px-2 py-1.5 w-full"
			value={selectedAnnotation.unit}
			onChange={(e) =>
				context.controller.handleOnUpdateSelection({
					unit: e.target.value as DimensionAnnotation["unit"],
				})
			}
		>
			{sizeUnits.map((unit) => (
				<option
					key={unit}
					value={unit}
				>
					{t(getUnitTranslationKey(unit))}
				</option>
			))}
		</select>
	);
}
